<ps-ui-modal class="sup-group-modal replica-modal">
  <ps-ui-modal-body>
    <h5 class="text-center modal-heading" psUiModalTitle>{{ tcType }}</h5>
    <h4
      class="text-center specific-audience"
      *ngIf="tcType === 'SPECIFIC AUDIENCE'"
    >
      Launch a new survey with custom specs
    </h4>
    <div class="row">
      <p class="boldFont">SURVEY-TITLE</p>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="inputLabel"> {{ tcSurveyNamePrefix }}</span>
        </div>
        <input
          type="text"
          class="form-control"
          id="name"
          placeholder="{{ tcSuveyName }}"
          name="name"
          [(ngModel)]="tcSuveyName"
        />
      </div>
      <div *ngIf="tcType === 'TARGETED LIST'" class="mt-2">
        <div class="form-group text-center" *ngIf="!hasPSIDRefList">
          <label for="files" class="upload-button"
            >Upload Respondent List</label
          >
          <input
            type="file"
            id="files"
            class="displayNone"
            accept=".xlsx,.xls,.csv"
            (change)="uploadPSID($event)"
          />
          <span style="position: static">|</span>
          <a class="upload-button" (click)="downloadFile('incl_excl.csv')"
            >Download Template</a
          >
        </div>
        <div class="form-group text-center" *ngIf="hasPSIDRefList">
          <a class="upload-button" (click)="openViewModal()"
            >View Respondent List
          </a>
          <span style="position: static">|</span>
          <a class="upload-button" (click)="openClearModal()">Clear Upload</a>
        </div>
      </div>
    </div>
    <div class="form-group mt-4" *ngIf="quotaOption?.length">
      <label for="quotaSelect" class="boldFont padSelectLabel">QUOTA</label>
      <select
        class="form-control slectBtn"
        id="quotaSelect"
        [(ngModel)]="selectedQuota"
      >
        <option value="" disabled selected>Choose Quota</option>
        <option *ngIf="tcType === 'REPLICA'" value="all">All Quotas</option>
        <option *ngFor="let quota of quotaOption" [value]="quota.category">
          {{ quota.category }}
        </option>
      </select>
    </div>

    <br />
    <div *ngIf="tcType === 'SPECIFIC AUDIENCE'" class="copy-targeting-div">
      <input
        id="copy-targeting-from-parent"
        type="checkbox"
        class="copy-targeting-input"
        [(ngModel)]="copyTargetingFromParent"
      />
      <label>Copy targeting from Parent</label>
    </div>

    <div class="text-center">
      <button
        type="button"
        class="save-launch"
        (click)="checkTcSurveys()"
        psUiButton
        [disabled]="tcType === 'TARGETED LIST' && hasPSIDRefList === false"
        psUiGtagEvent
        trackOn="click"
        action="launch_survey"
        category="Survey_Launch"
        id="save-and-launch-tc-survey"
        [params]="{ event_label: 'Targeted List Channel Launched' }"
      >
        Save & Launch Survey
      </button>
    </div>
  </ps-ui-modal-body>
</ps-ui-modal>
